import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
const ContentLayout = ({ children, className, paddingTop, paddingBottom, whiteBackground, notFluid, }) => notFluid ? (_jsx("div", { className: classNames(className, "w-100", {
        "bg-gray": !whiteBackground,
    }), children: _jsx("div", { className: classNames("container", {
            "pt-3": paddingTop,
            "pb-5": paddingBottom,
        }), children: children }) })) : (_jsx("div", { className: classNames(className, "w-100 container-fluid", {
        "pt-3": paddingTop,
        "pb-5": paddingBottom,
        "bg-light": !whiteBackground,
    }), children: children }));
export default ContentLayout;
